import { InjectionToken } from "@angular/core";

import type { IAuthProvider } from "./interfaces";

/** The active IdP implementation, selected by hostname in app.config.ts. */
export const AUTH_PROVIDER: InjectionToken<IAuthProvider> =
  new InjectionToken<IAuthProvider>("AUTH_PROVIDER");
